import { analytics } from 'analytics'
import { featureFlags } from './featureFlags'
import { FeatureFlagResponse } from './types'

export const featureFlagQueryKey = 'featureFlags'

// KG experiment: switch off anonymous Segment tracking
// This event fires with every page load - looking to see if we can reduce usage by silencing it.
// Can potentially bring this back the next time we run a test, maybe using `notsegment`.
const SPLIT_TESTS_ENABLED = false

export const triggerSplitTest = (data: FeatureFlagResponse) => {
  const networkFlags = data?.data?.feature_flags || []

  featureFlags.forEach((flag) => {
    if (
      !SPLIT_TESTS_ENABLED ||
      !flag.enabled ||
      flag.isStatic ||
      !flag.test?.length
    )
      return

    const flagExists = !!networkFlags.includes(flag.name)

    analytics.events.splitTestTriggered({
      name: flag.test,
      cohort: flagExists ? 'test' : 'control',
    })
  })
}
